import React, { useState } from "react";
import { motion } from "framer-motion";

import CharacterPicker, {
  getProfileIconFromDisplayName
} from "../character-picker";

interface PlayerLobbyRowProps {
  name: string;
  isOpen: boolean;
  isCurrentPlayer: boolean;
  onUpdatePlayer: (char: any) => void | undefined;
}

export const PlayerLobbyRow = ({
  name,
  isOpen,
  isCurrentPlayer,
  onUpdatePlayer
}: PlayerLobbyRowProps) => {
  const [pickerOpen, setPickerOpen] = useState(isCurrentPlayer);

  const openCharPicker = () => setPickerOpen(true);
  const updateCharacter = (char: any) => {
    onUpdatePlayer(char);
    setPickerOpen(false);
  };
  return (
    <div
      className={
        "player " +
        (isCurrentPlayer ? "player-host " : !isOpen ? "player-active " : " ")
      }
    >
      <motion.div
        className="player-image"
        whileHover={{ scale: isCurrentPlayer ? 1.1 : 1 }}
        onClick={isCurrentPlayer ? () => openCharPicker() : undefined}
        style={{
          backgroundImage: isOpen
            ? ""
            : `url(${getProfileIconFromDisplayName(name)})`
        }}
      ></motion.div>
      <motion.div
        whileHover={{ scale: isCurrentPlayer ? 1.01 : 1 }}
        className="player-nameplate"
        onClick={isCurrentPlayer ? () => openCharPicker() : undefined}
      >
        {name}
      </motion.div>
      <CharacterPicker isOpen={pickerOpen} onCharSelected={updateCharacter} />
    </div>
  );
};
